import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import PropTypes from "prop-types";

class OthersOutfitListView extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    callNextListFn: PropTypes.func.isRequired
  };

  render() {
    const { list, isLoading, isEnd, callNextListFn } = this.props;

    return (
      <OutfitListView
        list={list}
        isLoading={isLoading}
        isEnd={isEnd}
        callNextListFn={callNextListFn}
        emptyListText={null}
      />
    );
  }
}

export default OthersOutfitListView;
